import { createRoute, Outlet, useRouterState } from '@tanstack/react-router'

import { entityRoute } from '@/app/routes/entity-route'
import { activeNavigationItem, ProductGuard } from '@/app/routes/area-layout'
import { PermissionGate } from '@/ui/permission-gate'

export function IamRouteGuard() {
  const destination = useRouterState({
    select: (state) => activeNavigationItem('access', state.matches.at(-1)?.fullPath),
  })

  return (
    <ProductGuard product="access">
      {destination?.permission ? (
        <PermissionGate permission={destination.permission}>
          <Outlet />
        </PermissionGate>
      ) : (
        <Outlet />
      )}
    </ProductGuard>
  )
}

export const iamGuardRoute = createRoute({
  getParentRoute: () => entityRoute,
  id: 'iam-guard',
  component: IamRouteGuard,
})
